import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ShieldCheck, ArrowRight, CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import api from "@/lib/api";

export default function Terms() {
  const navigate = useNavigate();
  const [data, setData] = useState({ conditions: "", annual_discount_pct: 25, plans: [] });

  useEffect(() => {
    api.get("/service-plans").then(({ data }) => setData(data)).catch(() => {});
  }, []);

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col">
      <Navbar />
      <main className="flex-1 max-w-3xl w-full mx-auto px-5 sm:px-8 py-12">
        <div className="flex items-center gap-3">
          <span className="grid place-items-center h-11 w-11 rounded-xl bg-blue-600 text-white shadow-[0_0_18px_rgba(37,99,235,0.35)]">
            <ShieldCheck className="h-5 w-5" strokeWidth={2.2} />
          </span>
          <div>
            <p className="text-sm font-semibold uppercase tracking-widest text-blue-600">Serviceaftale</p>
            <h1 className="text-3xl sm:text-4xl font-display font-black tracking-tighter text-slate-900">Betingelser</h1>
          </div>
        </div>

        <p className="mt-4 text-slate-600">
          Læs betingelserne for J-Computers serviceaftale, inden du køber. Aftalen kan tilkøbes til både
          nyt og brugt udstyr, og ved årlig betaling sparer du {data.annual_discount_pct}%.
        </p>

        {data.plans?.length > 0 && (
          <div className="mt-8 grid gap-4 sm:grid-cols-3" data-testid="terms-plans">
            {data.plans.map((p) => (
              <div key={p.id} className={`rounded-2xl border p-5 ${p.popular ? "border-blue-600 bg-blue-50/60" : "border-slate-200 bg-white"}`}>
                <p className="text-sm font-semibold text-slate-500">{p.years} års aftale</p>
                <p className="mt-1 text-2xl font-display font-black tracking-tighter text-slate-900">
                  {p.monthly_price}<span className="text-sm font-bold text-slate-500"> kr./md</span>
                </p>
                <ul className="mt-3 space-y-1.5 text-sm text-slate-600">
                  {(p.features || []).map((f) => (
                    <li key={f} className="flex items-center gap-2"><CheckCircle2 className="h-4 w-4 text-blue-600 shrink-0" /> {f}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        )}

        <div className="mt-8 rounded-2xl border border-slate-200 bg-white p-6 sm:p-8">
          <h2 className="text-lg font-display font-bold text-slate-900">Fulde betingelser</h2>
          <p className="mt-3 text-slate-700 leading-relaxed whitespace-pre-line" data-testid="terms-conditions">
            {data.conditions || "Betingelserne er ikke tilgængelige lige nu."}
          </p>
        </div>

        <div className="mt-8 flex flex-wrap gap-3">
          <Button onClick={() => navigate("/booking?aftale=2&betaling=maanedlig")} data-testid="terms-book-btn"
            className="rounded-full h-12 px-7 bg-blue-600 hover:bg-blue-700 shadow-[0_0_24px_rgba(37,99,235,0.35)]">
            Book serviceaftale <ArrowRight className="ml-2 h-4 w-4" />
          </Button>
          <Button variant="outline" onClick={() => navigate("/")} className="rounded-full h-12 px-7 border-slate-300">
            Tilbage til forsiden
          </Button>
        </div>
      </main>
      <Footer />
    </div>
  );
}
